import isNotificationsDebug from './isNotificationsDebug';
export function debug(message, value) {
  if (isNotificationsDebug()) {
    if (value) {
      console.debug('NOTIFICATIONS - %s', message, value);
    } else {
      console.debug('NOTIFICATIONS - %s', message);
    }
  }
}